export default {
      id: "lely-bg-masked-usage",
      viewBox: "0 0 691 900",
      url: __webpack_public_path__ + "img/icons.50d286a4.svg#lely-bg-masked",
      toString: function () {
        return this.url;
      }
    }